import { ProductCustomization } from "@/stores/checkout-store";
import { MedusaMetada } from "@/types";
import { StoreProduct } from "@medusajs/types";

const getCustomizationMetadata = (product: StoreProduct | undefined) => {
  return product?.metadata as MedusaMetada | undefined;
};

export const isProductCustomizationComplete = (
  product: StoreProduct | undefined,
  customization: ProductCustomization | undefined
) => {
  if (!product) {
    return false;
  }

  const metadata = getCustomizationMetadata(product);

  const hasSurfaceOptions = Boolean(metadata?.surface_min && metadata?.surface_max && metadata?.surface_step);
  const hasHeightOptions = Boolean(metadata?.heights);
  const hasSurfaceTypeOptions = Boolean(metadata?.surfaces);

  if (hasSurfaceOptions && typeof customization?.surface !== "number") {
    return false;
  }

  if (hasHeightOptions && !customization?.height) {
    return false;
  }

  if (hasSurfaceTypeOptions && !customization?.surfaceType) {
    return false;
  }

  return true;
};
